import { useNavigate } from 'react-router';

import { paths } from '@/app/router/paths';
import { useSessionStore } from '@/shared/api';

import { tourStepsFor } from './tour-steps';
import { useTourStore } from './tour-store';

/**
 * De rondleiding opnieuw, vanuit Account: naar het dashboard, vanaf stap 1.
 * `null` als er voor deze sessie geen rondleiding is (geen omgeving, meekijken).
 */
export function useStartTour(): (() => void) | null {
    const navigate = useNavigate();
    const request = useTourStore((state) => state.request);
    const session = useSessionStore((state) => state.session);
    const impersonation = useSessionStore((state) => state.impersonation);

    if (tourStepsFor(session, impersonation).length === 0) {
        return null;
    }

    return () => {
        request();
        navigate(paths.dashboard);
    };
}
